@use "diy_base.module.scss";
@use "foundation/_colors.scss";
@use "foundation/_mixins.scss";
@use "foundation/responsive";

.step-selector {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  section.brand{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-bottom: calc(#{diy_base.$diy-composer-margin} * 1.2);

    @include diy_base.only-header-with-bg-color;

    @include responsive.phone {
      padding-bottom: calc(#{diy_base.$diy-composer-margin-phone} * 1.2);
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    max-width: 1444px; /* fixed: emulating container */
    margin-top: 2.5em;
  }

  li {
    display: flex;
    justify-content: initial;
    flex-direction: column;

    background-color: colors.$primary-text-color; /* only used if not applied service color */

    width: 16.666666667em;
    min-height: 14.444444444em;
    border-radius: diy_base.$border-radius;
    margin: 0.555555556em;
    padding: 1.555555556em; /* 28px */

    cursor: pointer;

    text-align: left;
    position: relative;

    a {
      color: #fff;

      span {
        display: inline-block;

        &.title {
          font-size: 1.333333333em; /* 24px */
          font-weight: 700;
          line-height: 1.125; /* 27px */
        }

        &.description {
          color: colors.$ifttt-next-dark-bg-text-color;
          font-size: 1.111111111em; /* 20px */
          line-height: 1.4;
          font-weight: 500;
          margin-top: 1em;
        }
      }

      &.badged {
        margin-bottom: 1.2em;

        @include responsive.phone {
          margin-bottom: 1.4em;
        }
      }
    }

    @include mixins.active-opacity;

    &.suggestion-card {
      background: colors.$primary-white;
      box-sizing: border-box;
      border: 4px solid colors.$primary-eerie-black;
      justify-content: center;
      a {
        color: colors.$primary-text-color;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .title {
          margin-top: .9em;
        }
      }

      @include responsive.phone {
        svg {
          height: 2.5em;
          width: 2.5em;
        }
      }
    }
  }

  .empty-list {
    font-size: 1.5em;
    font-weight: bold;
    margin: 3em auto;
  }
}
